function formatDate(value) {
    if (value && moment(value).isValid()) {
        return moment(value).format('D.M.YYYY')
    }
};
function formatDateLong(value) {
    if (value && moment(value).isValid()) {
        return moment(value).format('D MMMM YYYY')
    }
};
export default {formatDate, formatDateLong}